import { IMAGES, WEB_COLORS } from "@/lib/constants";
import { Stack, Typography } from "@mui/material";
import { useTranslations } from "next-intl";
import Image from "next/image";

const SecureDataComponent = ({ rbimsg = false, stackStyle, ...props }) => {
  const t = useTranslations("Common");
  return (
    <Stack
      direction="row"
      alignItems={{ xs: "flex-start", sm: "center" }}
      spacing={1}
      p={1.5}
      borderRadius={"12px"}
      bgcolor={WEB_COLORS.pale}
      flexGrow={1}
      width={"100%"}
    >
      <Image src={IMAGES.shield} alt="Secure shield" height={20} width={20} />
      <Typography variant="body2" align="left" color={WEB_COLORS.fadeColor} {...props}>
        {t.rich(rbimsg ? "rbiPanSecuredata" : "securedata", {
          bold: (c) => (
            <Typography
              color={WEB_COLORS.fadeColor}
              component={"span"}
              sx={{ opacity: 0.8 }}
              fontWeight={400}
              fontSize={{ xs: "0.6rem", sm: "0.8rem", md: "1rem" }}
            >
              {c}
            </Typography>
          ),
          shrink: (c) => (
            <Typography
              color={WEB_COLORS.fadeColor}
              sx={{ opacity: 0.8 }}
              component={"span"}
              fontWeight={300}
              fontSize={{ xs: "0.6rem", sm: "0.8rem", md: "1rem" }}
            >
              {c}
            </Typography>
          ),
        })}
      </Typography>
    </Stack>
  );
};

export default SecureDataComponent;
